const films = {
  "20 ans d'écart": {
    title: "20 ans d'écart",
    poster:
      "https://media.senscritique.com/media/000006452688/150/20_ans_d_ecart.jpg",
    tags: ["romantique"],
  },
  Jackpot: {
    title: "Jackpot",
    poster: "https://media.senscritique.com/media/000000090885/150/Jackpot.jpg",
    tags: ["romantique"],
  },
  "Kate et William : quand tout a commencé...": {
    title: "Kate et William : quand tout a commencé...",
    poster:
      "https://media.senscritique.com/media/000004881862/150/Kate_et_William_quand_tout_a_commence.jpg",
    tags: ["romantique"],
  },
  "La Copine de mon meilleur ami": {
    title: "La Copine de mon meilleur ami",
    poster:
      "https://media.senscritique.com/media/000000005779/150/La_Copine_de_mon_meilleur_ami.jpg",
    tags: ["romantique"],
  },
  "L'Abominable Vérité": {
    title: "L'Abominable Vérité",
    poster:
      "https://media.senscritique.com/media/000000071559/150/L_Abominable_Verite.jpg",
    tags: ["romantique"],
  },
  "Twilight : Chapitre 1 - Fascination": {
    title: "Twilight : Chapitre 1 - Fascination",
    poster:
      "https://media.senscritique.com/media/000004677899/150/Twilight_Chapitre_1_Fascination.jpg",
    tags: ["romantique"],
  },
  "Twilight : Chapitre 3 - Hésitation": {
    title: "Twilight : Chapitre 3 - Hésitation",
    poster:
      "https://media.senscritique.com/media/000007137956/150/Twilight_Chapitre_3_Hesitation.jpg",
    tags: ["romantique"],
  },
  "Twilight : Chapitre 5 - Révélation, 2e partie": {
    title: "Twilight : Chapitre 5 - Révélation, 2e partie",
    poster:
      "https://media.senscritique.com/media/000005622117/150/Twilight_Chapitre_5_Revelation_2e_partie.jpg",
    tags: ["romantique"],
  },
  "Les Infidèles": {
    title: "Les Infidèles",
    poster:
      "https://media.senscritique.com/media/000004675533/150/Les_Infideles.jpg",
    tags: ["romantique"],
  },
  "Angel-A": {
    title: "Angel-A",
    poster: "https://media.senscritique.com/media/000000174367/150/Angel_A.jpg",
    tags: ["romantique"],
  },
  "Alien vs. Predator": {
    title: "Alien vs. Predator",
    poster:
      "https://media.senscritique.com/media/000007873700/150/Alien_vs_Predator.jpg",
    tags: ["romantique"],
  },
  "Aliens vs. Predator : Requiem": {
    title: "Aliens vs. Predator : Requiem",
    poster:
      "https://media.senscritique.com/media/000004402948/150/Aliens_vs_Predator_Requiem.jpg",
    tags: ["romantique"],
  },
  "Star Wars : Épisode I - La Menace fantôme": {
    title: "Star Wars : Épisode I - La Menace fantôme",
    poster:
      "https://media.senscritique.com/media/000009575209/150/Star_Wars_Episode_I_La_Menace_fantome.jpg",
    tags: ["nouveautees"],
  },
  "Le Dernier Maître de l'air": {
    title: "Le Dernier Maître de l'air",
    poster:
      "https://media.senscritique.com/media/000004543244/150/Le_Dernier_Maitre_de_l_air.jpg",
    tags: ["nouveautees"],
  },
  "La Stratégie Ender": {
    title: "La Stratégie Ender",
    poster:
      "https://media.senscritique.com/media/000005603363/150/La_Strategie_Ender.jpg",
    tags: ["nouveautees"],
  },
  "Palais royal !": {
    title: "Palais royal !",
    poster:
      "https://media.senscritique.com/media/000004674984/150/Palais_royal.jpg",
    tags: ["nouveautees"],
  },
  "Star Wars : Épisode II - L'Attaque des clones": {
    title: "Star Wars : Épisode II - L'Attaque des clones",
    poster:
      "https://media.senscritique.com/media/000005243882/150/Star_Wars_Episode_II_L_Attaque_des_clones.jpg",
    tags: ["nouveautees"],
  },
  Lucy: {
    title: "Lucy",
    poster: "https://media.senscritique.com/media/000006965038/150/Lucy.jpg",
    tags: ["nouveautees"],
  },
  "Da Vinci Code": {
    title: "Da Vinci Code",
    poster:
      "https://media.senscritique.com/media/000000173873/150/Da_Vinci_Code.jpg",
    tags: ["nouveautees"],
  },
  "Terminator 3 : Le Soulèvement des machines": {
    title: "Terminator 3 : Le Soulèvement des machines",
    poster:
      "https://media.senscritique.com/media/000005021783/150/Terminator_3_Le_Soulevement_des_machines.jpg",
    tags: ["nouveautees"],
  },
  "RoboCop 3": {
    title: "RoboCop 3",
    poster:
      "https://media.senscritique.com/media/000007746461/150/Robo_Cop_3.jpg",
    tags: ["nouveautees"],
  },
  "Comme chiens et chats : La Revanche de Kitty Galore": {
    title: "Comme chiens et chats : La Revanche de Kitty Galore",
    poster:
      "https://media.senscritique.com/media/000016168496/150/Comme_chiens_et_chats_La_Revanche_de_Kitty_Galore.jpg",
    tags: ["nouveautees"],
  },
  "Mr. & Mrs. Smith": {
    title: "Mr. & Mrs. Smith",
    poster:
      "https://media.senscritique.com/media/000004689769/150/Mr_Mrs_Smith.jpg",
    tags: ["nouveautees"],
  },
  "Lara Croft : Tomb Raider": {
    title: "Lara Croft : Tomb Raider",
    poster:
      "https://media.senscritique.com/media/000000047500/150/Lara_Croft_Tomb_Raider.jpg",
    tags: ["nouveautees"],
  },
  "Batman Forever": {
    title: "Batman Forever",
    poster:
      "https://media.senscritique.com/media/000006424552/150/Batman_Forever.jpg",
    tags: ["actions"],
  },
  "Batman & Robin": {
    title: "Batman & Robin",
    poster:
      "https://media.senscritique.com/media/000012313556/150/Batman_Robin.jpg",
    tags: ["actions"],
  },
  "Wanted : Choisis ton destin": {
    title: "Wanted : Choisis ton destin",
    poster:
      "https://media.senscritique.com/media/000006581339/150/Wanted_Choisis_ton_destin.jpg",
    tags: ["actions"],
  },
  "World Invasion : Battle Los Angeles": {
    title: "World Invasion : Battle Los Angeles",
    poster:
      "https://media.senscritique.com/media/000000169177/150/World_Invasion_Battle_Los_Angeles.jpg",
    tags: ["actions"],
  },
  Battleship: {
    title: "Battleship",
    poster:
      "https://media.senscritique.com/media/000000175597/150/Battleship.jpg",
    tags: ["actions"],
  },
  "Abraham Lincoln : Chasseur de vampires": {
    title: "Abraham Lincoln : Chasseur de vampires",
    poster:
      "https://media.senscritique.com/media/000004153574/150/Abraham_Lincoln_Chasseur_de_vampires.jpg",
    tags: ["actions"],
  },
  Priest: {
    title: "Priest",
    poster: "https://media.senscritique.com/media/000000022949/150/Priest.jpg",
    tags: ["actions"],
  },
  "Resident Evil": {
    title: "Resident Evil",
    poster:
      "https://media.senscritique.com/media/000004463939/150/Resident_Evil.jpg",
    tags: ["actions"],
  },
  "Resident Evil : Extinction": {
    title: "Resident Evil : Extinction",
    poster:
      "https://media.senscritique.com/media/000000142516/150/Resident_Evil_Extinction.jpg",
    tags: ["actions"],
  },
  "Superman Returns": {
    title: "Superman Returns",
    poster:
      "https://media.senscritique.com/media/000008173782/150/Superman_Returns.jpg",
    tags: ["actions"],
  },
  Tekken: {
    title: "Tekken",
    poster: "https://media.senscritique.com/media/000000120827/150/Tekken.jpg",
    tags: ["actions"],
  },
  Godzilla: {
    title: "Godzilla",
    poster:
      "https://media.senscritique.com/media/000006952542/150/Godzilla.jpg",
    tags: ["actions"],
  },
  "Les blagues de Toto": {
    title: "Les blagues de Toto",
    poster:
      "https://m.media-amazon.com/images/M/MV5BNGI2NWQ1YmYtNGNiMC00N2E3LThjYTYtMzExZDcyZGQ2NTUxXkEyXkFqcGdeQXVyMTAwMzM3NDI3._V1_UY268_CR8,0,182,268_AL_.jpg",
    tags: ["humours"],
  },
  "Johnny English": {
    title: "Johnny English",
    poster:
      "https://m.media-amazon.com/images/M/MV5BMjI4MjQ3MjI5MV5BMl5BanBnXkFtZTgwNjczMDE4NTM@._V1_.jpg",
    tags: ["humours"],
  },
  Borat: {
    title: "Borat",
    poster:
      "https://images-na.ssl-images-amazon.com/images/I/51uGbGa68JL._AC_SY445_.jpg",
    tags: ["humours"],
  },
  "Ted 2 Unrated": {
    title: "Ted 2 Unrated",
    poster:
      "https://images-na.ssl-images-amazon.com/images/I/812Dbpg0IuL._SL1500_.jpg",
    tags: ["humours"],
  },
  "Epic Movie": {
    title: "Epic Movie",
    poster:
      "https://m.media-amazon.com/images/M/MV5BMTA3NDM5ODU3NzleQTJeQWpwZ15BbWU3MDgyMjgyNDE@._V1_UY209_CR0,0,140,209_AL_.jpg",
    tags: ["humours"],
  },
  "Astérix aux Jeux olympiques": {
    title: "Astérix aux Jeux olympiques",
    poster:
      "https://media.senscritique.com/media/000004633407/150/Asterix_aux_Jeux_olympiques.jpg",
    tags: ["humours"],
  },
  "Taxi 4": {
    title: "Taxi 4",
    poster: "https://media.senscritique.com/media/000005618246/150/Taxi_4.jpg",
    tags: ["humours"],
  },
  "La Beuze": {
    title: "La Beuze",
    poster:
      "https://media.senscritique.com/media/000004674521/150/La_Beuze.jpg",
    tags: ["humours"],
  },
  "Les Visiteurs en Amérique": {
    title: "Les Visiteurs en Amérique",
    poster:
      "https://media.senscritique.com/media/000004668456/150/Les_Visiteurs_en_Amerique.jpg",
    tags: ["humours"],
  },
  Iznogoud: {
    title: "Iznogoud",
    poster:
      "https://media.senscritique.com/media/000004952644/150/Iznogoud.jpg",
    tags: ["humours"],
  },
  "Les Trois Frères : Le Retour": {
    title: "Les Trois Frères : Le Retour",
    poster:
      "https://media.senscritique.com/media/000006280192/150/Les_Trois_Freres_Le_Retour.jpg",
    tags: ["humours"],
  },
  "Scary Movie 4": {
    title: "Scary Movie 4",
    poster:
      "https://media.senscritique.com/media/000007119254/150/Scary_Movie_4.jpg",
    tags: ["humours"],
  },
  Fiston: {
    title: "Fiston",
    poster: "https://media.senscritique.com/media/000007863397/150/Fiston.jpg",
    tags: ["francais"],
  },
  "Mais qui a tué Pamela Rose ?": {
    title: "Mais qui a tué Pamela Rose ?",
    poster:
      "https://media.senscritique.com/media/000004673906/150/Mais_qui_a_tue_Pamela_Rose.jpg",
    tags: ["francais"],
  },
  "Ma femme s'appelle Maurice": {
    title: "Ma femme s'appelle Maurice",
    poster:
      "https://media.senscritique.com/media/000000139351/150/Ma_femme_s_appelle_Maurice.png",
    tags: ["francais"],
  },
  Supercondriaque: {
    title: "Supercondriaque",
    poster:
      "https://media.senscritique.com/media/000007894218/150/Supercondriaque.jpg",
    tags: ["francais"],
  },
  Barbecue: {
    title: "Barbecue",
    poster:
      "https://media.senscritique.com/media/000006885551/150/Barbecue.jpg",
    tags: ["francais"],
  },
  "Les Profs": {
    title: "Les Profs",
    poster:
      "https://media.senscritique.com/media/000004669934/150/Les_Profs.jpg",
    tags: ["francais"],
  },
  "Connasse, princesse des cœurs": {
    title: "Connasse, princesse des cœurs",
    poster:
      "https://media.senscritique.com/media/000009431115/150/Connasse_princesse_des_coeurs.jpg",
    tags: ["francais"],
  },
  Vidocq: {
    title: "Vidocq",
    poster: "https://media.senscritique.com/media/000004745665/150/Vidocq.jpg",
    tags: ["francais"],
  },
  "Les Aventures de Philibert, capitaine puceau": {
    title: "Les Aventures de Philibert, capitaine puceau",
    poster:
      "https://media.senscritique.com/media/000006801808/150/Les_Aventures_de_Philibert_capitaine_puceau.png",
    tags: ["francais"],
  },
  "Prête-moi ta main": {
    title: "Prête-moi ta main",
    poster:
      "https://media.senscritique.com/media/000004677848/150/Prete_moi_ta_main.jpg",
    tags: ["francais"],
  },
  "Les Misérables": {
    title: "Les Misérables",
    poster:
      "https://media.senscritique.com/media/000004351268/150/Les_Miserables.jpg",
    tags: ["francais"],
  },
  "Les Nouvelles Aventures d'Aladin": {
    title: "Les Nouvelles Aventures d'Aladin",
    poster:
      "https://media.senscritique.com/media/000011295418/150/Les_Nouvelles_Aventures_d_Aladin.jpg",
    tags: ["francais"],
  },
};

export default films;